function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { generateColorScale } from "../css";
import lmTheme from "./lmTheme";
var blue = "#0060c6";

var blues = _extends({}, generateColorScale(blue), {
  "50": "#e6eff9",
  "100": "#b0ceed",
  "200": "#8ab6e5",
  "300": "#5494d9",
  "400": "#3380d1",
  "500": "#0060c6",
  "600": "#0057b4",
  "700": "#00448d",
  "800": "#00356d",
  "900": "#002853"
});

var green = "#09a869";

var greens = _extends({}, generateColorScale(green), {
  "50": "#e1f5ed",
  "100": "#b5e5d2",
  "200": "#84d4b4",
  "300": "#53c296",
  "400": "#2eb580",
  "500": "#09a869",
  "600": "#068755",
  "700": "#06774b",
  "800": "#055c3a",
  "900": "#04472c"
});

var red = "#df1f2b";

var reds = _extends({}, generateColorScale(red), {
  "50": "#fbe4e6",
  "100": "#f5bcbf",
  "200": "#ef8f95",
  "300": "#e9626b",
  "400": "#e4414b",
  "500": "#df1f2b",
  "600": "#d2121a",
  "700": "#ca0a10",
  "800": "#9e161f",
  "900": "#7b1118"
});

var orange = "#ff7022";

var oranges = _extends({}, generateColorScale(orange), {
  "50": "#ffeee4",
  "100": "#ffd4bd",
  "200": "#ffb891",
  "300": "#ff9b64",
  "400": "#ff8543",
  "500": "#ff7022",
  "600": "#e8661f",
  "700": "#b55018",
  "800": "#8c3e13",
  "900": "#6b2f0e"
});

var theme = _extends({}, lmTheme, {
  colors: _extends({}, lmTheme.colors, {
    blue: blue,
    blues: blues,
    blueHover: "#007bff",
    bluePressed: blues[700],
    blueSelected: blues[900],
    green: green,
    greens: greens,
    greenHover: greens[400],
    greenPressed: greens[700],
    greenSelected: greens[800],
    red: red,
    reds: reds,
    redHover: reds[400],
    redPressed: reds[700],
    redSelected: reds[800],
    orange: orange,
    oranges: oranges,
    orangeHover: oranges[400],
    orangePressed: oranges[700],
    orangeSelected: oranges[800],
    info: blue,
    success: green,
    warning: orange,
    error: red
  })
});

export default theme;